import type { FaireProductEntity } from "../../entity_types/product";

export const p_qjjrqcf39t: FaireProductEntity = {
  token: "p_qjjrqcf39t",
  type: "product",
  name: "Who Doesn't Want a Little Kitchen Towel",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/511290b3979a9aaf56c1501e9e55953493c0ea76ae92afeb9a3a7abc96aa47ce.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f13926a6f2af0279b05c5f7d29dbdf161c045439a4e261b98031bb9acae6d612.jpeg",
    "https://cdn.faire.com/fastly/572432fa289f87957bf50dba8813eaceacdb0bca97f812edccd99d01047c044a.jpeg",
    "https://cdn.faire.com/fastly/b3f021e7947956684c5746ca57bfc4890d1089b81398cd2efc104cc4ef32151a.jpeg",
    "https://cdn.faire.com/fastly/0f8fae9e3097f6f8029a6ecceb8e748bf582a8db447ff55b1236aa856057d9a2.jpeg",
    "https://cdn.faire.com/fastly/def40c2518714c94bfae36c1295682de6a4a80ad55a3f9de1041c2a34e190c37.jpeg",
    "https://cdn.faire.com/fastly/5685623dfa5a9e3014afbb3232015ff9282729d5bc6e846ec3afed3d2ba11d26.jpeg"
  ],
  priceDollars: 8,
  description: "A microfiber kitchen towel from our Valentine's Day Collection featuring an all-over design displaying a pattern of donkeys with a funny love-themed sentiment that reads \"Who Doesn't Want A Little Ass?\" Donkey inspired pattern is replicated from playful hand illustrated artwork. Double-sided towel displays a coordinating stripe pattern on the back that offers multiple display options with a cotton tape hanger in the corner for hanging. Our Who Doesn't Want A Little kitchen towel is conveniently machine washable for easy cleaning. Microfiber towel is packaged on a cardboard hanger with hole to easily display on store rack. A fun love-themed gift perfect for both friends and partners on Valentine's Day or in everyday moments.",
  tags: [],
  msrpDollars: 15.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:10.348Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
